import styled from 'styled-components';
import { fonts } from 'styles';

export const Container = styled.main`
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
`;

export const Content = styled.section`
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 93px 0;
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (max-width: 500px) {
    padding: 0 32px;
  }
`;

export const Title = styled.h1`
  font-family: ${fonts.BentonSansWideBlack};
  font-size: 58px;
  line-height: 64px;
  text-align: center;
  text-transform: uppercase;
  color: #fff;
  margin-bottom: 16px;

  span {
    color: #e29434;
  }

  @media screen and (max-width: 500px) {
    max-width: 240px;
    font-size: 42px;
    line-height: 46px;
  }
`;

export const Subtitle = styled.h2`
  font-family: 'Playfair Display', serif;
  font-size: 28px;
  line-height: 34px;
  text-align: center;
  color: #fff;
  margin-bottom: 32px;

  @media screen and (max-width: 500px) {
    font-size: 20px;
    line-height: 25px;
  }
`;

export const Author = styled.div`
  width: max-content;
  padding: 32px 18px 0 18px;
  border-top: 1px solid #fff;
  font-family: ${fonts.BentonSansMedium};
  font-size: 15px;
  line-height: 20px;
  text-align: center;
  color: #fff;
  margin-bottom: 56px;

  span {
    display: block;
    margin-top: 16px;
    font-family: ${fonts.BentonSansRegular};
  }
`;

export const Text = styled.article`
  width: 100%;
  max-width: 800px;
  margin-bottom: 80px;
  font-family: ${fonts.BentonSansRegular};
  font-size: 16px;
  line-height: 28px;
  color: #e2e2e2;

  .drop-caps:first-letter {
    font-size: 4em;
    float: left;
    padding: 0 10px 0 0;
    font-family: ${fonts.BentonSansWideBlack};
    line-height: 1em;
  }

  p {
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  @media screen and (max-width: 500px) {
    padding: 0 32px;
    margin-bottom: 56px;
    line-height: 26px;
  }
`;

export const VideoWrapper = styled.div`
  width: 100%;
  max-width: 1280px;
  position: relative;
  padding-top: 56.25%;
  margin-bottom: 80px;

  .react-player {
    position: absolute;
    top: 0;
    left: 0;
  }

  @media screen and (max-width: 500px) {
    margin-bottom: 56px;
  }
`;

export const Separator = styled.div`
  width: 76px;
  height: 5px;
  background-color: #fff;
  margin-bottom: 80px;
`;
